var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${
    _vm.barChartRankingVisitantes.chartData.labels.length * 8
  }px;max-width:100%;`)},[_c('horizontalBar-chart',{attrs:{"id":"horizontalBar-chart-ranking-visitantes","height":250,"chart-data":_vm.barChartRankingVisitantes.chartData,"extra-options":_vm.barChartRankingVisitantes.extraOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }